import { SystemNotice } from "../models/systemNotice/systemNotice";
import { SystemNoticesWebService } from "../webservices/system-notices.web.service";
import { BaseService } from "./base.service";
import { userManagementService } from "./user-management.service";
import { retryWithAuth } from "./utils/retryWithAuth";

export class SystemNoticesService extends BaseService {
  private static instance: SystemNoticesService;

  private constructor() {
    super();
  }

  public static getInstance(): SystemNoticesService {
    if (!SystemNoticesService.instance) {
      SystemNoticesService.instance = new SystemNoticesService();
    }
    return SystemNoticesService.instance;
  }

  private getService(): SystemNoticesWebService {
    return new SystemNoticesWebService();
  }

  public async getPublicActive(): Promise<SystemNotice[]> {
    try {
      const result = await this.getService().getPublicActive();
      return result ?? [];
    }
    catch {
      return [];
    }
  }

  public async getAccountActive(): Promise<SystemNotice[]> {
    try {
      const organisatie = userManagementService.getStoredOrganisatie();
      const result = await retryWithAuth(
        () => this.getService().getAccountActive(organisatie?.id),
        1,
        { redirectOnForbidden: false, redirectOnNotFound: false, redirectOnServerError: false },
      );
      return result ?? [];
    }
    catch {
      // Geen rechten of niet ingelogd: geen accountmeldingen tonen.
      return [];
    }
  }

  // Haalt beide endpoints altijd parallel op; account-fouten worden in
  // getAccountActive afgehandeld zodat publieke meldingen wel blijven werken.
  public async getActiveNotices(): Promise<SystemNotice[]> {
    const tasks: Promise<SystemNotice[]>[] = [
      this.getPublicActive(),
      this.getAccountActive(),
    ];

    const results = await Promise.all(tasks);
    const byId = new Map<string, SystemNotice>();
    for (const notice of results.flat()) {
      if (notice && notice.id) {
        byId.set(notice.id, notice);
      }
    }
    return Array.from(byId.values());
  }
}

export const systemNoticesService = SystemNoticesService.getInstance();
